import e from "../../utils/classNames.js";
import { createButtonRipple as t } from "../../utils/buttonEffect.js";
import { getAutoTrackingAttributes as n } from "../../utils/analytics/autoTracking.js";
import r from "../tooltip/SimpleTooltip.js";
import i from "../icon/Icon.js";
import { forwardRef as a, useState as o } from "react";
import { noop as s } from "es-toolkit/function";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
//#region src/components/button/Button.tsx
var u = {
	DEFAULT: "default",
	UNSTYLED: "unstyled",
	PRIMARY: "primary",
	SECONDARY: "secondary",
	INFO: "info",
	WARNING: "warning",
	DANGER: "danger",
	SUCCESS: "success",
	MUTED: "muted",
	MUTED_FILLED: "muted-filled"
}, d = {
	VARIANT_LINK: "link",
	VARIANT_LINK_INLINE: "link-inline",
	VARIANT_OUTLINE: "outline",
	VARIANT_ACTION: "action"
}, f = {
	XS: "xs",
	SM: "sm",
	MD: "md",
	LG: "lg"
}, p = a((a, u) => {
	let { as: f = "button", active: p = !1, disabled: m = !1, asToggle: h = !1, onClick: g = s, bsStyle: _ = "default", bsSize: v, variant: y, iconOnly: b = !1, iconName: x, hoverIconName: S, icon: C, hoverIcon: w, iconRight: T = !1, multiline: E = !1, block: D = !1, hoverScale: O = !1, className: k = "", tooltip: A, noRippleEffect: j = !1, autoTrackingKey: M, type: N = "button", tabIndex: P = 0, children: F, "aria-label": I, title: L, ...R } = a, z = n({
		autoTrackingKey: M,
		props: R,
		source: "button"
	}), [B, V] = o(p), [H, U] = o(!1), W = !m && H && (S ?? w) ? S ?? w : x ?? C, G = S || w ? {
		onMouseEnter: (e) => {
			if (m) return;
			U(!0);
			let t = R.onMouseEnter;
			t?.(e);
		},
		onMouseLeave: (e) => {
			U(!1);
			let t = R.onMouseLeave;
			t?.(e);
		}
	} : {}, [K, q] = o(p);
	p !== K && (V(p), q(p));
	let J = (e) => {
		if (j || t(e.nativeEvent, e.currentTarget), h) {
			let t = !B;
			V(t), t && e.currentTarget.blur(), g(t);
		} else g(e);
	}, Y = (e) => {
		if (m) {
			e.preventDefault();
			return;
		}
		j || t(e.nativeEvent, e.currentTarget), g(e);
	}, X = e("btn", `btn-${_}`, y === d.VARIANT_LINK && "btn-link", y === d.VARIANT_LINK_INLINE && "btn-link btn-link-inline", y === d.VARIANT_OUTLINE && "btn-outline", y === d.VARIANT_ACTION && "btn-action", v && `btn-${v}`, h && "btn-toggle", B && "active", b && "btn-icon-only", T && "btn-icon-right", E && "btn-multiline", D && "btn-block", O && "hover-scale", f === "a" && "gap-0", f === "a" && m && "disabled", "btn-component", k), Z = A != null && A !== !1, Q = f === "a" ? /* @__PURE__ */ l("a", {
		ref: u,
		...R,
		...z,
		className: X,
		onClick: Y,
		"aria-label": I,
		"aria-disabled": m || void 0,
		tabIndex: m ? -1 : P,
		title: Z ? void 0 : L,
		...G,
		children: [W && /* @__PURE__ */ c(i, { iconName: W }), F]
	}) : /* @__PURE__ */ l("button", {
		ref: u,
		type: N,
		...R,
		...z,
		className: X,
		onClick: J,
		disabled: m,
		tabIndex: P,
		"aria-label": I,
		title: Z ? void 0 : L,
		...G,
		children: [W && /* @__PURE__ */ c(i, { iconName: W }), F]
	});
	if (!Z) return Q;
	let $ = m && f !== "a" ? /* @__PURE__ */ c("span", {
		className: e(D ? "display-block" : "display-inline-flex"),
		children: Q
	}) : Q;
	return /* @__PURE__ */ c(r, {
		content: A,
		delay: {
			show: 250,
			hide: 0
		},
		className: "max-width-200",
		children: $
	});
});
Object.assign(p, u), Object.assign(p, d), Object.assign(p, f);
//#endregion
export { f as SIZES_MAP, u as STYLES_MAP, d as VARIANTS_MAP, p as default };

//# sourceMappingURL=Button.js.map